import React from 'react';
import { useController } from 'react-hook-form';
import { TextField } from '@mui/material';

/**
 * Input 컴포넌트 Props
 * @typedef {Object} InputProps
 * @property {Object} textFieldProps - MUI TextField의 props
 * @property {Object} control - react-hook-form의 control 객체
 * @property {string} name - 필드 이름
 * @property {Object} [rules] - 유효성 검사 규칙
 */

const Input = ({
  textFieldProps,
  control,
  name,
  rules,
  ...props
}) => {
  const {
    field,
    fieldState,
  } = useController({
    control,
    name,
    rules,
    ...props,
  });

  return (
    <TextField
      {...textFieldProps}
      {...field}
      error={!!fieldState.error}
      helperText={fieldState.error?.message}
    />
  );
};

export default Input;
